import { memo, useContext } from "react";
import { Box, ChevronDown, Icon } from "@storyofams/react-ui";
import { usePostHog } from "posthog-js/react";
import { ColorProvider } from "~components/common/Layout";
import { HugeStroke } from "~components/common/Story/components/HugeStroke";
import { Stroke } from "~components/common/Story/components/Stroke";
import { Text } from "~components/common/Text";
import { countDiscount } from "~lib/shopify/utils/countDiscount";

interface TieredDiscount {
  foundVariant: any;
  discountTag?: string;
  showDiscounts: boolean;
  strokeColor?: string;
  setShowDiscounts: (open: any) => void;
}

export const TieredDiscount: React.FC<TieredDiscount> = memo(
  ({
    foundVariant,
    discountTag,
    showDiscounts,
    strokeColor,
    setShowDiscounts,
  }): JSX.Element => {
    const { color } = useContext(ColorProvider);
    const posthog = usePostHog();
    const { twoPcs, fourPcs, sixPcs, twoDiscount, fourDiscount, sixDiscount } =
      countDiscount(foundVariant, discountTag);
    return (
      <Box
        height={"max-content"}
        pl={[1, "20px"]}
        mb={[2, 0]}
        width={"100%"}
        borderLeft={`4px solid ${strokeColor || color}`}
      >
        <Text fontSize={"14px"} color="grey600">
          Stapelkorting
        </Text>
        <Box
          fontSize={["16px", "20px"]}
          width={"100%"}
          display="flex"
          justifyContent={"space-between"}
        >
          <Box
            position={"relative"}
            justifySelf={"center"}
            flexDirection="column"
          >
            {showDiscounts ? (
              <HugeStroke color={strokeColor || color} top={[-3, 0]} />
            ) : (
              <Stroke color={strokeColor || color} top={[-0.5, 1]} />
            )}
            <Box position={"relative"} zIndex={1}>
              <Text as="span" fontWeight={500}>
                {twoPcs}
              </Text>
              <Text as="span"> p/s bij 2 stuks </Text>
              <Text as="span">{`(${twoDiscount}% korting)`}</Text>
            </Box>
            {showDiscounts && (
              <Box position={"relative"} zIndex={1}>
                <Box>
                  <Text as="span" fontWeight={500}>
                    {fourPcs}
                  </Text>
                  <Text as="span"> p/s bij 4 stuks </Text>
                  <Text as="span">{` (${fourDiscount}% korting)`}</Text>
                </Box>
                <Box>
                  <Text as="span" fontWeight={500}>
                    {sixPcs}
                  </Text>
                  <Text as="span"> p/s bij 6 stuks </Text>
                  <Text as="span">{` (${sixDiscount}% korting)`}</Text>
                </Box>
              </Box>
            )}
          </Box>
          <Text
            fontWeight={500}
            css={{ textDecoration: "underline" }}
            onClick={(e) => {
              if (!showDiscounts) posthog.capture("clicked_staplekorting");
              setShowDiscounts((open: any) => !open);
              e.stopPropagation();
              e.preventDefault();
            }}
            ml={1}
            fontSize={["15px", "18px"]}
            alignSelf="end"
            cursor="pointer"
          >
            {showDiscounts ? "minder" : "meer"}{" "}
            <Icon
              transform={showDiscounts && "rotate(180deg)"}
              fontSize={"12px"}
              icon={ChevronDown}
            ></Icon>
          </Text>
        </Box>
      </Box>
    );
  }
);
